"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deprecations = [
    {
        condition: /\.recipe900$/g,
        message: '`recipe900` is deprecated. Please use `recipe400` instead.'
    }
];
